import styled from '@emotion/styled';
import MuiTab, { TabOwnProps, tabClasses } from '@mui/material/Tab';
import MuiTabs, { tabsClasses } from '@mui/material/Tabs';

import { exists } from '@web/utils/exists';

export const tabsCustomClasses = {
  root: 'tabRoot',
};

const Tabs = styled(MuiTabs)`
  &.${tabsClasses.root} {
    min-height: unset;
    border-radius: ${({ theme }) => theme.spacing('0750')};
    background-color: ${({ theme }) => theme.color.surfaceContainerLowest};
    padding: ${({ theme }) => theme.spacing('0250')};
  }

  .${tabsClasses.flexContainer} {
    position: relative;
    z-index: 1;

    gap: ${({ theme }) => theme.spacing('0250')};
  }
  .${tabsClasses.indicator} {
    height: unset;
    top: 0;
    border-radius: ${({ theme }) => theme.spacing('0500')};
    background-color: ${({ theme }) => theme.color.surfaceContainerHigh};
  }
`;

const Tab = styled(MuiTab)`
  &.${tabClasses.root} {
    color: ${({ theme }) => theme.color.onSurface};
    min-height: unset;
    min-width: unset;
    flex: 1;
    height: ${({ theme }) => theme.size['1875']};
    padding: ${({ theme }) => theme.spacing('0500')};
    font: ${({ theme }) => theme.typography.body.regular};
    font-size: ${({ theme }) => theme.typescale.size['0875']};
  }

  .${tabClasses.iconWrapper} {
    height: ${({ theme }) => theme.size['1000']};
    width: ${({ theme }) => theme.size['1000']};
    margin-right: ${({ theme }) => theme.spacing('0500')};
  }
`;

export interface IMenuSwitcherOption<SwitcherValue> {
  icon: TabOwnProps['icon'];
  iconPosition: TabOwnProps['iconPosition'];
  label?: string;
  value: SwitcherValue;
}

export interface IMenuSwitcherProps<SwitcherValue> {
  compact?: boolean;
  value: SwitcherValue;
  options: Array<IMenuSwitcherOption<SwitcherValue>>;
  className?: string;
  onChange(mode: SwitcherValue): void;
}
export function MenuSwitcher<SwitcherValue>({
  value,
  compact,
  options,
  onChange,
  className,
}: IMenuSwitcherProps<SwitcherValue>) {
  return (
    <Tabs
      value={value}
      onChange={(_event, _value) => onChange(_value)}
      className={[className, tabsCustomClasses.root].filter(exists).join(' ')}
    >
      {options.map((option) => (
        <Tab
          key={String(option.value)}
          icon={option.icon}
          iconPosition={option.iconPosition}
          label={compact ? undefined : option.label}
          aria-label={option.label}
          value={option.value}
          disableRipple
        />
      ))}
    </Tabs>
  );
}
